import styled from 'styled-components'
import { FilterList, PARAM_SORT, PARAM_FILTER, CategoryList } from '../../../common'
import { SelectSort } from '../../molecules'
import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useContext, useEffect, useState } from 'react'
import { StoresContext } from '../../../provider/StoreProvider'

type Props = {
  filterData?: {
    filterList: FilterList
    filterType: string
    setFilterType: (type: PARAM_FILTER) => void
  }
  sortData?: {
    sortList: FilterList
    setSortType: (type: PARAM_SORT) => void
  }
  slideFilterData?: {
    filterList: FilterList
    filterType: string
    setFilterType: (type: PARAM_FILTER) => void
  }
  categoryData?: {
    categoryIds: number
    setCategoryIds: (id: number) => void
  }
}

export const ParamOption: React.FC<Props> = ({ filterData, sortData, slideFilterData, categoryData }) => {
  const { commonStore } = useContext(StoresContext)
  const categoryListStore = commonStore.categoryList
  const [categoryList, setCategoryList] = useState<CategoryList>()

  // 카테고리 리스트 병합 ( 백엔드 API DATA + "전체", "기타")
  useEffect(() => {
    if (categoryListStore.content == null || categoryListStore.content.length < 1) {
      return
    }
    const list = [
      {
        id: 0,
        name: '전체',
        description: '',
      },
      ...categoryListStore.content,
      {
        id: -1,
        name: '기타',
        description: '',
      },
    ]
    setCategoryList(list)
  }, [categoryListStore.content])

  return (
    <>
      {categoryData && categoryList && categoryList.length > 0 && (
        <SSwiper slidesPerView={'auto'} spaceBetween={5} freeMode={true} speed={300} modules={[FreeMode]}>
          {categoryList &&
            categoryList.map((d, i) => (
              <SwiperSlide key={i}>
                <SlideChip
                  className={`${categoryData.categoryIds === d.id ? 'active' : ''}`}
                  onClick={() => categoryData.setCategoryIds(d.id)}
                >
                  {d.name ?? '-'}
                </SlideChip>
              </SwiperSlide>
            ))}
        </SSwiper>
      )}
      {slideFilterData && (
        <SSwiper slidesPerView={'auto'} spaceBetween={5} freeMode={true} speed={300} modules={[FreeMode]}>
          {slideFilterData.filterList.map((d, i) => (
            <SwiperSlide key={i}>
              <SlideChip
                className={`${slideFilterData.filterType === d.type ? 'active' : ''}`}
                onClick={() => slideFilterData.setFilterType(d.type as PARAM_FILTER)}
              >
                {d.title ?? '-'}
              </SlideChip>
            </SwiperSlide>
          ))}
        </SSwiper>
      )}
      <OptionContainer>
        {filterData && (
          <FilterContainer>
            {filterData.filterList.map((d, i) => (
              <span
                key={i}
                className={`${filterData.filterType === d.type ? 'active' : ''}`}
                onClick={() => filterData.setFilterType(d.type as PARAM_FILTER)}
                style={{ paddingLeft: '0px' }}
              >
                {d.title}
              </span>
            ))}
          </FilterContainer>
        )}
        {sortData && (
          <SelectWrap>
            <SelectSort setSortType={sortData.setSortType} sortList={sortData.sortList} />
          </SelectWrap>
        )}
      </OptionContainer>
    </>
  )
}

const OptionContainer = styled.section`
  display: flex;
  align-items: center;
  padding: 0 20px;
`

const FilterContainer = styled.div`
  width: 100%;
  color: #92949c;
  font-size: 13px;
  span {
    padding: 0 10px 0 0;
    :hover {
      cursor: pointer;
    }
  }
  span.active {
    font-weight: bold;
    @media (prefers-color-scheme: light) {
      color: black;
    }
    @media (prefers-color-scheme: dark) {
      color: white;
    }
  }
`

const SSwiper = styled(Swiper)`
  padding: 16px 20px 0;
  height: 46px;
  .swiper-slide {
    width: auto;
    height: 30px;
  }
`

const SlideChip = styled.span`
  border: solid 1px var(--ion-color-gray100);
  border-radius: 13px;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 400;
  margin-right: 8px;
  :hover {
    cursor: pointer;
  }
  &.active {
    border: none;
    font-weight: bold;
    background-color: var(--ion-color-primary_dark);
    color: var(--ion-color-white);
  }
`

const SelectWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  height: 60px;
`
